export default {
	personalCenter: {
		vip_member: 'VIP-статус',
		vip: {
			level_label: 'Уровень VIP{level}', next_level: 'Следующий: VIP{level}',
			points_summary: 'Накоплено {current} очков. До VIP{level} осталось {remaining}.',
			level_rewards: 'Награды уровня', reward_title: 'Награды VIP{level}', exclusive_rewards: 'Эксклюзивные награды', promotion_reward: 'Награда за VIP{level}',
			previous_level: 'Предыдущий уровень', next_level_button: 'Следующий уровень',
			dragon_key: 'Ключ души дракона ×{count}', battle_shard: 'Фрагмент узора ×{count}', forge_crystal: 'Кристалл ковки ×{count}',
			unlocked: 'VIP{level} достигнут. Награда доступна.', locked: 'VIP{level} пока не достигнут.',
			claim: 'Получить', claiming: 'Получение...', claimed: 'Получено', claim_success: 'Награда VIP{level} получена', claim_failed: 'Не удалось получить награду. Повторите попытку позже.',
			points_label: 'Баллы', go_redeem: 'Обменять',
			experience_summary: 'Текущий опыт: {current}; до VIP{level} осталось {remaining}',
			max_level: 'Макс. уровень!', current_experience: 'Текущий опыт: {current}'
		},
		title: 'Личный кабинет', my_exchange: 'Мои обмены', my_points: 'Мои баллы', lottery_records: 'История розыгрышей', recharge_records: 'История пополнений',
		redeem_gift: 'Активировать подарок', redeem_description: 'Введите код, чтобы отправить награду выбранному персонажу.', redeem_code: 'Код активации', redeem_code_placeholder: 'Введите код активации', redeeming: 'Активация...', redeem_now: 'Активировать', rebate_coupon: 'Купон возврата {percent}%',
		points_details: 'История баллов', exchange_time: 'Время активации', reward_content: 'Награда', status: 'Статус', time: 'Время', type: 'Тип', points_change: 'Изменение баллов', balance: 'Баланс', lottery_time: 'Время розыгрыша', reward: 'Награда',
		order_id: 'Номер заказа', payment_channel: 'Способ оплаты', amount: 'Сумма', server: 'Сервер', role: 'Персонаж', payment_time: 'Время оплаты', copy: 'Копировать',
		loading: 'Загрузка...', no_records: 'Подходящих записей нет', no_content: 'Нет данных для отображения.', previous: 'Назад', next: 'Далее', page_info: 'Страница {current} / {total}',
		source_recharge_reward: 'Награда за пополнение', source_official_activity: 'Событие на сайте', source_item_exchange: 'Обмен предметов',
		exchange_success: 'Код успешно активирован', exchange_failed: 'Не удалось активировать код', enter_redeem_code: 'Введите код активации', exchange_retry: 'Не удалось активировать код. Повторите попытку позже.',
		copy_success: 'Скопировано', copy_failed: 'Не удалось скопировать', lottery_load_failed: 'Не удалось загрузить историю розыгрышей', lottery_load_retry: 'Не удалось загрузить историю розыгрышей. Повторите попытку позже.',
		recharge_load_failed: 'Не удалось загрузить историю пополнений', recharge_load_retry: 'Не удалось загрузить историю пополнений. Повторите попытку позже.', points_load_failed: 'Не удалось загрузить историю баллов', points_load_retry: 'Не удалось загрузить историю баллов. Повторите попытку позже.',
		exchange_records_load_failed: 'Не удалось загрузить историю обменов', exchange_records_load_retry: 'Не удалось загрузить историю обменов. Повторите попытку позже.'
	},
	member_popup: {
		title: 'Очки участника начислены!',
		message: 'За это пополнение начислено {points} очков. До VIP{nextLevel} осталось {remaining} очков.',
		progress: 'Накоплено за пополнения {current} / {target}',
		next: 'До VIP{nextLevel} осталось {remaining} очков',
		suppress: 'Не показывать 7 дней',
		later: 'Позже',
		rewards: 'Получить награды',
		close: 'Закрыть уведомление'
	},
	member_level: {
		title: 'Уровень участника',
		points_progress: 'Накопленные очки',
		next_level: 'До VIP{level} осталось:',
		points_unit: 'очков',
		view_rewards: 'Награды за уровень'
	},
	login_button_text: 'Вход',
	logining_button_text: 'Вход',
	account_input_text: 'Введите привязанную почту',
	password_input_text: 'Введите пароль',
	other_login_methods_text: 'Другие способы входа',
	top_up_center_text: 'Центр перезарядки',
	benefit_text: 'Благосостояние',
	sign_in_text: 'Вход',
	log_out_text: 'Выход',
	service_terms_text: 'Условия обслуживания',
	privacy_policy_text: 'Политика конфиденциальности',
	official_apk_download_text: 'Скачать официальную APK-версию',
	official_facebook_text: 'Официальный лаунж',
	recharge_instructions_text: 'Инструкции по пополнению',
	rebate_countdown_title: 'Ограниченный кэшбэк активен',
	rebate_countdown_label: 'Обратный отсчёт',
	rebate_countdown_days: 'дн.',
	rebate_countdown_hours: 'ч.',
	rebate_countdown_minutes: 'мин.',
	rebate_countdown_seconds: 'сек.',
	log_in_game_account_text: 'Войдите в аккаунт',
	sign_in_lowercase_text: 'Вход',
	instructions_text: 'Уведомление',
	confirm_text: 'Подтвердить',
	cancel_text: 'Отмена',
	switch_character_text: 'Выбрать персонажа',
	copy_successful_text: 'Копирование успешно',
	claimed_text: 'Получено',
	claim_success_text: 'Успешно получено',
	claim_text: 'Получить',
	claim_unmet_text: 'Не выполнено',
	contact_customer_service_text: 'Связаться с поддержкой',
	home_page_text: 'Главный экран',
	payment_successful_text: 'Оплата прошла успешно!',
	purchase_confirm_text: 'Подтверждение покупки',
	payment_channels_text: 'Способ оплаты',
	payment_button_text: 'Купить',
	original_price_text: 'Обычная цена',
	discounts_text: 'Скидка',
	earn_points_text: 'Получать баллы',
	rebates_text: 'Кэшбэк',
	amount_text: 'Цена',
	insufficient_points_text: 'Недостаточный интеграл',
	insufficient_lottery_count_text: 'Недостаточно попыток',
	network_error_retry_text: 'Ошибка сети. Повторите попытку позже.',
	score_lottery_text: 'Лотерея очков',
	score_lottery_entrance_error: 'Ошибка запроса входа в лотерею очков:',
	lottery_current_points_label: 'Текущие очки:',
	lottery_points_recharge_tip: 'Баллы можно получить путем пополнения счета.',
	lottery_spin_label: 'Колесо призов',
	lottery_rule_button: 'Правила',
	lottery_rule_popup_title: 'Правила события',
	lottery_record_button: 'История призов',
	lottery_record_title: 'История призов',
	lottery_record_empty: 'Нет записей',
	lottery_record_time: 'Время',
	lottery_record_prize: 'Приз',
	lottery_daily_limit: 'Дневной лимит достигнут',
	lottery_remaining_count: 'Осталось попыток {count}',
	lottery_draw_cost: '{cost} баллов',
	lottery_init_data_error: 'Ошибка запроса данных лотереи очков:',
	daily_rewards_text: 'Ежедневная награда',
	points_text: 'Магазин баллов',
	winning_award_text: "Поздравляю с наградой.",
	points_limit_tips_text: "Награда уже получена. Дождитесь перезарядки для повторного обмена.",
	receive_reward_tips_text: "Награда отправлена на почту вашего персонажа! Войдите в игру, чтобы получить её.!",
	hot_title_text: "HOT",
	limit_title_text: "LIMIT",
	limit_text: "Limit",
	sell_out_text: "Прададзены",
	copy_fail_text: "Не удалось скопировать",
	payment_type_text: "Платежный канал",
	order_id_text: "Номер заказа",
	payment_time_text: "Время оплаты",
	copy_text: "Копировать",
	amount_text: "Сумма",
	game_server_text: "Сервер",
	game_role_text: "Персонаж",
	orders_records_text: "История пополнений",
	no_data_text: 'Нет данных',
	orders_tips_text: "Согласно настройкам системы, история пополнений доступна только за последние 30 дней",
	pointsDescribeText: 'За пополнение счёта вы получите 10% кэшбэка в виде баллов, которые можно бесплатно обменять на предметы в магазине баллов!',
	pointsBalanceText: 'Ваши баллы',
	points_period_daily: 'Сегодня',
	points_period_week: 'Эта неделя',
	points_period_month: 'Этот месяц',
	points_period_lifetime: 'Пожизненно',
	points_tag_mustBuy: 'Маст-бай',
	points_tag_selected: 'Избранное',
	points_tag_discount: 'Скидки',
	points_tag_perk: 'Бонусы',
	coupon: {
		discount_label: 'Купон на кэшбэк',
		title_html: 'Получите дополнительный бонус <br/>при покупке с этим купоном.',
		expired_text: 'Истек',
		used_text: 'Использован',
		countdown_prefix: 'Обратный отсчет',
		activity_button_text: 'Розыгрыш купона кэшбэка'
	},
	pagination: {
		previous: "Назад",
		next: "Вперед",
		page_info: "Страница {current} из {total}"
	},
	// Support
	support_my_questions: 'Мои вопросы',
	support_submit_issue: 'Отправить вопрос',
	support_records_title: 'Мои обращения',
	support_records_desc: 'Проверяйте прогресс и добавляйте информацию.',
	support_refresh: 'Обновить',
	support_tabs_label: 'Вкладки поддержки',
	support_load_more: 'Загрузить ещё',
	support_user_id: 'ID пользователя',
	support_game: 'Игра',
	support_platform: 'Платформа',
	support_back: 'Назад',
	support_mark_solved: 'Решено',
	support_official_support: 'Официальная поддержка',
	support_image: 'Изображение',
	support_reply_hint: 'Ваше дополнение будет отправлено в поддержку',
	support_send: 'Отправить',
	support_sending: 'Отправка...',
	support_player: 'Игрок',
	support_attachment_preview: 'Предпросмотр вложения',
	support_remove_attachment: 'Удалить вложение',
	support_attachment_fallback: 'Вложение',
	support_survey_title: 'Опрос',
	support_survey_message: 'Ваша проблема решена?',
	support_survey_close: 'Закрыть',
	support_submit_success: 'Успешно отправлено',
	support_submit_fail: 'Ошибка отправки',
	support_close_success: 'Чат закрыт',
	support_close_fail: 'Не удалось закрыть',
	support_rate_title: 'Пожалуйста, оцените качество обслуживания',
	support_input_placeholder: 'Введите содержание...',
	support_image_pick_error: 'Не удалось получить путь изображения',
	support_send_fail: 'Не удалось отправить',
	support_evaluate_success: 'Оценка успешно отправлена',
	support_evaluate_fail: 'Ошибка отправки оценки',
	support_status_unreplied: 'Без ответа',
	support_status_replied: 'Отвечено',
	support_status_resolved: 'Решено',
	support_status_pending_review: 'Ожидает оценки',
	support_form_type_label: 'Тип вопроса',
	support_form_type_placeholder: 'Выберите тип вопроса',
	support_form_desc_label: 'Описание вопроса',
	support_form_desc_placeholder: 'Подробно опишите проблему...',
	support_form_upload_label: 'Вложения',
	support_form_upload_click: 'Загрузить файл',
	support_form_upload_tips: '(изображения до 10MB, видео до 50MB, максимум 5 файлов)',
	support_form_submit: 'Отправить',
	support_form_image_too_big: 'Размер изображения не должен превышать 10MB',
	support_form_video_too_big: 'Размер видео не должен превышать 50MB',
	support_type_topup: 'Проблема с пополнением',
	support_type_account: 'Проблема с аккаунтом',
	support_type_guide: 'Руководство по игре',
	support_type_suggestion: 'Предложения',
	support_type_event: 'Проблема с событием',
	support_type_report: 'Сообщить о нарушении',
	support_type_other: 'Другое',
	support_type_topup_hint: 'Пополнение не поступило, неверная сумма',
	support_type_account_hint: 'Вход, блокировка, привязка',
	support_type_guide_hint: 'Геймплей, задания, прогресс',
	support_type_suggestion_hint: 'Отзывы и предложения',
	support_type_report_hint: 'Читы, оскорбления, нарушения',
	support_type_other_hint: 'Другая проблема',
	support_type_topup_code: 'Pay',
	support_type_account_code: 'Acc',
	support_type_guide_code: 'Tip',
	support_type_suggestion_code: 'Idea',
	support_type_report_code: 'Rpt',
	support_type_other_code: 'Etc',
	support_submitting: 'Отправка...',
	rebate_limited_text: '🔥 Кэшбэк {pct}% (лимит)',
	rebate_percent_text: 'Кэшбэк {pct}%',
	coupon_booster_label: 'Бонусный купон',
	coupon_expires_after: 'Истекает через {time}',
	coupon_threshold_shortfall: 'Добавьте ещё {amount}',
	coupon_product_excluded: 'Недоступно для этого товара',
	coupon_channel_restricted: 'Только для оплаты через {channels}',
	coupon_unavailable_title: 'Недоступные купоны',
	coupon_skip_text: 'Без купона',
	coupon_count_unit: ' шт.',
	coupon_picker_title: 'Выбрать купон',
	coupon_entry_label: 'Купоны',
	coupon_available_count: 'Доступно: {count}',
	coupon_no_use_text: 'Без купона',
	coupon_best_tag: 'Лучший',
	coupon_expired_text: 'Истёк',
	close_text: 'Закрыть',
	discount_coupon_label: 'Купон на скидку',
	coupon_single_use_hint: 'Для одного заказа можно использовать один купон',
	order_amount_text: 'Сумма заказа',
	discount_amount_text: 'Скидка по купону',
	payable_amount_text: 'К оплате',
	coupon_extra_rebate_notice: 'Дополнительный возврат 50% будет отправлен по почте. Обратитесь в поддержку для регистрации.',
	payment_recommended_text: 'Рекомендуемый способ',
	payment_enjoy_rebate: 'Кэшбэк {pct}%',
	payment_order_rebate: 'Кэшбэк за заказ: {amount}',
	payment_order_discount: 'Скидка на заказ: {amount}',
	recommend_text: 'Рекомендуем',
	payment_other_methods_text: 'Другие способы оплаты',
	super_coupon_title: 'Суперкупоны на ограниченное время',
	super_coupon_end_time: 'Событие завершится:',
	super_coupon_previous_activity: 'Предыдущее предложение',
	super_coupon_recommended: 'Выгодное предложение',
	super_coupon_view_details: 'Подробнее о наборе купонов',
	super_coupon_value_label: 'Общая сумма скидок',
	super_coupon_contents: 'Состав набора купонов',
	super_coupon_threshold: 'От {amount}',
	super_coupon_discount: 'Скидка {amount}',
	super_coupon_remaining: 'Осталось {time}',
	super_coupon_purchased: 'Куплено',
	super_coupon_buy_now: 'Купить',
	super_coupon_next_activity: 'Следующее предложение',
	super_coupon_switcher: 'Навигация по предложениям',
	super_coupon_switch_to: 'Перейти к предложению {index}',
	super_coupon_details_title: 'Подробнее о наборе купонов',
	super_coupon_close_details: 'Закрыть описание набора купонов',
	super_coupon_empty: 'Нет доступных купонов на скидку',
	super_coupon_instructions: 'Условия использования',
	super_coupon_confirm: 'Понятно',
	super_coupon_package_name: 'Набор суперкупонов',
	super_coupon_get_coupons: 'Купоны на скидку сразу после покупки: {count}',
	super_coupon_reward_multiple: 'Выгода примерно в {multiple} раза',
	super_coupon_purchase_limit: 'Не более {count} наб. за покупку',
	super_coupon_purchase_interval: 'Интервал между покупками: {days} дн.',
	super_coupon_rule_separator: ', ',
	super_coupon_unknown_status: 'Неизвестный статус',
	super_coupon_date_format: '{day}.{month}.{year} {time}',
	super_coupon_used: 'Использован',
	super_coupon_expired: 'Истёк',
	super_coupon_unit_day: 'день',
	super_coupon_unit_days: 'дней',
	super_coupon_unit_hour: 'час',
	super_coupon_unit_hours: 'часов',
	super_coupon_unit_minute: 'минута',
	super_coupon_unit_minutes: 'минут',
	super_coupon_valid_for: 'Срок действия: {value} {unit}'
}
